<template>
    <div>
        <div class="edit-title">schema配置</div>
        <el-tag :key="index" v-for="(tag, index) in dynamicTags" :closable="!getDisabled" :type="selectDataIndex==index?'':'info'" :disable-transitions="false" @click="selectData(index,tag)" @close="handleClose(tag)">
            {{tag.name}}
        </el-tag>
        <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" style="width: 300px;" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm" placeholder="请输入物理库schema">
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新增scame</el-button>
        <div v-for="(tag, index) in dynamicTags" class="box-dynamicTags">
            <!-- 搜索 -->
            <div class="search_box" v-if="selectDataIndex == index" >
                <el-form :model="tag" ref="ruleForm" label-width="180px" class="demo-ruleForm" inline :disabled="getDisabled">
                    <el-form-item label="物理库Schema名称:" label-width="150px" prop="name" :rules="[
                        {required: true, message: '名称不能为空',trigger: 'blur'},
                        {min: 1, max: 50, message: '名称不能超过50个字符', trigger: 'blur'}
                    ]">
                        <el-input v-model="tag.name" placeholder="名称不能超过50个字符" maxlength="50" @blur="getName(tag.name)"></el-input>
                    </el-form-item>
                    <el-form-item label="物理库Schema描述:" label-width="150px"   :rules="[
                        {required: true, message: '描述不能为空',trigger: 'blur'},
                    ]">
                        <el-input v-model="tag.description" placeholder="物理库Schema描述" @blur="getDesc(tag.description)"></el-input>
                    </el-form-item>
                    <el-form-item label="要绑定的逻辑库Schema:" required>
                        <el-select placeholder="请选择要绑定的逻辑库Schema" v-model="tag.logicalSchemaId" @change="changeGetSt">
                            <el-option :label="item.name" :value="item.id" v-for="item in logicalDataBaseIDList" :key="item.name"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="0px" label=" ">
                        <el-button type='primary' class="button-new-tag" style="margin-left: -10px;" size="small" @click="editSchemaClick">保存</el-button>
                    </el-form-item>
                    <el-button class="button-new-tag floatButton marginBottomClass" size="small" type="primary" @click="addForm">+ 新增Table</el-button>
                </el-form>
            </div>
            <!-- table -->
            <el-table v-if="selectDataIndex == index" :data="tableData" border highlight-current-row style="margin-top: 24px;" :header-cell-style="{ background: '#f2f2f2' }">
                <el-table-column label="序号" type="index" align="center" width="100">
                </el-table-column>
                <el-table-column prop="id" label="物理库Table名称" align="center">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.editStatus" v-model="scope.row.name" placeholder="物理库Table名称"></el-input>
                        <span v-if="!scope.row.editStatus">{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" align="center" label="要绑定的逻辑库Table">
                    <template slot-scope="scope">
                        <el-select placeholder="请选择" v-model="scope.row.logicalTableId" v-if="scope.row.editStatus">
                            <el-option :label="item.name" :value="item.id" v-for="item in luojiTable" :key="item.name"> </el-option>
                        </el-select>
                        <span v-if="!scope.row.editStatus">{{scope.row.logicalTableName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" align="center" label="描述">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.editStatus" v-model="scope.row.description" placeholder="请输入"></el-input>
                        <span v-if="!scope.row.editStatus">{{scope.row.description}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="editTable(scope.row)" v-if="!scope.row.editStatus" type="primary" size="small">编辑
                        </el-button>
                        <el-button @click="saveTable(scope.row)" v-if="scope.row.editStatus" type="success" size="small">保存
                        </el-button>
                        <el-button @click="concelAddTable(scope.row)" v-if="scope.row.editStatus" size="small">取消
                        </el-button>
                        <el-button @click="deleteTable(scope.row)" type="error" size="small" v-if="!scope.row.editStatus">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import {
    getListByDataBaseId,
    addOrEditTable,
    getTableList,
    getListBySchemaID,
    deletePhysicalTable,
    addOrEditSchemaID,
    deletePhysicalSchema
} from "@/apis/pipelineService/physicalDb";
import {
    getLogicalListByDataBaseId,
    getListBySchemaIDOfLogical
} from "../../../apis/pipelineService/logicalDb";
export default {
    data() {
        return {
            moduleName: "",
            inputValue: "", // 输入框input
            dynamicTags: [],
            inputVisible: false,
            selectDataIndex: 0, // 选中key
            selectValue: {}, // 选中data
            tableData: [], //
            logicalDataBaseIDList: [], // 逻辑库schema列表
            luojiTable: [], // 逻辑库Table列表
            isFlag: false // 防止重复请求接口
        };
    },
    mounted() {
        this.getLogicalListByDataBaseId();
        if (this.$route.query.type !== "add") {
            this.getListByDataBaseId(); // 加载物理库schema列表
        }
    },
    computed: {
        getDisabled() {
            return {
                add: false,
                edit: false,
                details: true
            }[this.$route.query.type];
        }
    },
    props: ["logicalDataBaseID"],
    methods: {
        // 新增Table
        addForm() {
            if (
                !this.selectValue.name ||
                !this.selectValue.logicalSchemaId ||
                !this.selectValue.description ||
                !this.selectValue.id
            ) {
                this.$message.warning(
                    "请填写并保存完物理库schemema信息后添加！"
                );
                return false;
            }
            let obj = {};
            this.tableData.push({
                name: "",
                logicalTableId: "",
                editStatus: true
            });
        },
        // 删除物理库Schema
        handleClose(tag) {
            if(!tag.id) {
                this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
                return false
            }
            this.deleteData(tag, "Schema");
        },
        showInput() {
            this.isFlag = false
            this.inputValue = "";
            this.inputVisible = true;
            // this.getListByDataBaseId()  // 加载物理库schema列表
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        // 新增物理库schema
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue && !this.isFlag) {
                this.isFlag = true
                this.dynamicTags.push({
                    name: this.inputValue,
                    logicalSchemaId: "", // 逻辑库schemaId
                    id: "", // 主键id
                    description: ""
                });
                this.inputVisible = false;
                this.selectDataIndex = this.dynamicTags.length - 1;
                this.selectValue = {
                    ...this.dynamicTags[this.selectDataIndex]
                };
                this.tableData = [];
            } else {
                this.inputVisible = false;
            }
        },
        // 编辑table
        editTable(data) {
            this.$set(data, "editStatus", true);
        },
        // 保存table
        saveTable(data) {
            if (!data.logicalTableId || !data.name || !data.description) {
                this.$message.warning("信息填写完整后再保存");
                return false;
            }
            this.addOrEditTable(data);
        },
        // 删除table
        deleteTable(data) {
            this.deleteData(data, "Table");
        },
        // 选择Schema
        selectData(index, tag) {
            if (this.selectDataIndex == index) {
                return false;
            }
            this.tableData = [];
            this.selectDataIndex = index;
            this.selectValue = tag;
            this.getListBySchemaID(); // 获取当前物理库schema下的Table
        },
        // 修改 按钮
        editSchemaClick() {
            if (
                !this.selectValue.name ||
                !this.selectValue.logicalSchemaId ||
                !this.selectValue.description
            ) {
                this.$message.warning(
                    "请填写完信息再保存！"
                );
                return false;
            }
            this.addOrEditSchemaID();
        },
        // 获取物理库Schema列表
        async getListByDataBaseId(idData) {
            let params = {
                physicalDataBaseId: this.$route.query.id // 集群id
            };
            try {
                const data = await getListByDataBaseId(params);
                if (data.code == 0 && data.data) {
                    this.dynamicTags = data.data;
                    if (this.dynamicTags && this.dynamicTags.length > 0) {
                        if(!idData) {
                            this.selectValue = this.dynamicTags[0];
                        }
                        this.getListBySchemaID();
                    }
                }
            } catch (error) {}
        },
        // 根据物理库SchemaId获取Table列表
        async getListBySchemaID() {
            let params = {
                physicalSchemaID: this.selectValue.id
            };
            try {
                const data = await getListBySchemaID(params);
                if (data.code == 0 && data.data) {
                    this.tableData = data.data;
                    this.getListBySchemaIDOfLogical(
                        this.selectValue.logicalSchemaId
                    );
                }
            } catch (error) {}
        },
        // 新增或修改Schema
        async addOrEditSchemaID() {
            let params = {
                physicalDbId: this.$route.query.id,
                name: this.inputValue || this.selectValue.name,
                id: this.selectValue.id,
                logicalSchemaId: this.selectValue.logicalSchemaId,
                description: this.selectValue.description
            };
            if (!this.selectValue.id) {
                delete params.id;
            }
            try {
                const data = await addOrEditSchemaID(params);
                if (data.code == 0) {
                    this.$message.success(data.message || "保存成功");
                    if (!this.selectValue.id) {
                        this.selectValue.id = data.data.id;
                        this.inputValue = "";
                        this.getListByDataBaseId(this.selectValue.id)
                    }
                } else {
                    this.$message.error(data.message || "保存失败");
                    this.inputValue = null;
                    this.inputVisible = false;
                    // this.getListByDataBaseId()
                }
            } catch (error) {}
        },
        // 新增或修改Table保存
        async addOrEditTable(data) {
            let params = {
                physicalSchemaId: this.selectValue.id,
                name: data.name,
                id: data.id,
                logicalTableId: data.logicalTableId,
                description: data.description
            };
            if (!data.id) {
                delete params.id;
            }
            try {
                const data = await addOrEditTable(params);
                if (data.code == 0) {
                    this.$message.success(data.message || "保存成功");
                    this.getListBySchemaID();
                }else {
                    this.$message.error(data.message || "保存失败");
                    this.getListBySchemaID();
                }
            } catch (error) {}
        },
        // 删除提示
        deleteData(data, type) {
            this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    if (type == "Schema") {
                        this.deletePhysicalSchema(data);
                    } else {
                        this.deletePhysicalTable(data);
                    }
                })
                .catch(() => {});
        },
        // 删除Schema接口
        async deletePhysicalSchema(tag) {
            const params = {
                id: tag.id
            };
            try {
                const data = await deletePhysicalSchema(params);
                if (data.code == 0) {
                    this.$message.success(data.message || "删除成功");
                    this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
                }else {
                    this.$message.error(data.message || "删除失败");
                }
            } catch (error) {}
        },
        // 删除Table接口
        async deletePhysicalTable(tag) {
            const params = {
                id: tag.id
            };
            try {
                const data = await deletePhysicalTable(params);
                if (data.code == 0) {
                    this.$message.success(data.message || "删除成功");
                    this.tableData.splice(this.tableData.indexOf(tag), 1);
                }else {
                    this.$message.error(data.message || "删除失败");
                }
            } catch (error) {}
        },
        // 取消添加Table
        concelAddTable(data) {
            if (data.id) {
                this.$set(data, "editStatus", false);
                this.getListBySchemaID();
            } else {
                this.tableData.splice(this.tableData.indexOf(data), 1);
            }
        },
        changeGetSt(data) {
            if (data) {
                this.selectValue.logicalSchemaId = data;
                this.getListBySchemaIDOfLogical(data);
            }
        },
        getDesc(data) {
            this.selectValue.description = data;
        },
        getName(data) {
            this.selectValue.name = data;
        },
        // 获取逻辑库schema列表
        async getLogicalListByDataBaseId() {
            let params = {
                logicalDataBaseID: this.logicalDataBaseID // 集群id
            };
            try {
                const data = await getLogicalListByDataBaseId(params);
                if (data.code == 0 && data.data) {
                    console.log(this.logicalDataBaseIDList)
                    this.logicalDataBaseIDList = data.data;
                }
            } catch (error) {}
        },
        // 根据schemaId获取table列表
        async getListBySchemaIDOfLogical(data) {
            let params = {
                logicalSchemaID: data
            };
            try {
                const res = await getListBySchemaIDOfLogical(params);
                if (res.code == 0 && res.data) {
                    this.luojiTable = res.data;
                }
            } catch (error) {}
        }
    }
};
</script>
<style lang="less" scoped>
.search_box {
    padding-top: 20px;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
.info {
    width: 100%;
    margin: 0 auto;
    background: #f8f8f8;
    border-radius: 10px;
    padding-top: 20px;
    margin-bottom: 20px;
}
h5 {
    font-size: 18px;
    padding: 15px;
    font-weight: 700;
    color: #666;
    border-bottom: 1px solid #ddd;
    margin-bottom: 40px;
}
.edit-title {
    margin-top: 40px;
}
.buttonMarginClass {
    margin-left: 20px;
}
.floatButton {
    float: right;
}
.marginBottomClass {
    margin-bottom: 16px;
}
.box-dynamicTags {
    margin-bottom: 30px;
}
</style>

